import { City } from 'country-state-city';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import validator from 'validator';
import Button from '../../Component/Button/Button';
import CustomPhoneInput from '../../Component/CustomPhoneInput';
import DropDown from '../../Component/DropDown/DropDown';
import Header from '../../Component/Header';
import HeroSection from '../../Component/HeroSection';
import Input from '../../Component/Input/Input';
import TextArea from '../../Component/TextArea';
import { imageUrl } from '../../config/apiUrl';
import {
  enquiryTypeOptions,
  floorLevelOptions,
  furnishingOptions,
  parkingSpaceOptions,
  preferredContactMethodOptions,
  propertyOrientationOptions,
  propertyStatusOptions
} from '../../constant/commonData';
import { usePostRequestMutation } from '../../store/apiSlice/apiSlice';
import { getSelectedLanguagePage } from '../../utils/helpers';
import classes from './PropertyRequest.module.css';
import Footer from '../../Component/Footer';

const PropertyRequest = () => {
  const { accessToken } = useSelector((state) => state.authReducer);
  const { t } = useTranslation('propertyRequest');
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const propertyTypesOptions = useSelector((state) => state.commonReducer?.propertyTypes);
  const interiorAmenitiesOptions = useSelector((state) => state.commonReducer?.interiorAmenities);
  const exteriorAmenitiesOptions = useSelector((state) => state.commonReducer?.exteriorAmenities);
  const { cmsPages } = useSelector((state) => state.commonReducer);
  const pageData = getSelectedLanguagePage(selectedLanguage, cmsPages, 'propertyRequest');

  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [contactMethod, setContactMethod] = useState('');
  const [enquiryType, setEnquiryType] = useState('');
  const [propertyType, setPropertyType] = useState('');
  const [city, setCity] = useState('');
  const [street, setStreet] = useState('');
  const [budget, setBudget] = useState('');
  const [area, setArea] = useState('');
  const [rooms, setRooms] = useState('');
  const [bathrooms, setBathrooms] = useState('');
  const [furnishing, setFurnishing] = useState('');
  const [floorLevel, setFloorLevel] = useState('');
  const [propertyStatus, setPropertyStatus] = useState('');
  const [parkingSpace, setParkingSpace] = useState('');
  const [view, setView] = useState('');
  const [additionalRequest, setAdditionalRequest] = useState('');
  const [consentCheck, setConsentCheck] = useState(false);
  const [inAmenities, setInAmenities] = useState([]);
  const [exAmenities, setExAmenities] = useState([]);

  const [apiFunc, { isLoading: loading }] = usePostRequestMutation();

  // Get All Cities of Turkey
  const getCities = City.getCitiesOfCountry('TR');
  const handleSubmit = async () => {
    const params = {
      fullName: name,
      email: email,
      phoneNumber: phone,
      contactMethod: contactMethod?.value,
      city: city?.name,
      propertyType: propertyType?._id,
      bedrooms: rooms,
      enquiryType: enquiryType?.value,
      budget,
      bathrooms,
      area,
      street,
      parkingSpace: parkingSpace,
      propertyStatus: propertyStatus,
      interiorAmenities: inAmenities.map((item) => item._id),
      exteriorAmenities: exAmenities.map((item) => item._id),
      furnishing: furnishing?.value,
      floorLevel: floorLevel,
      viewAndOrientation: view,
      requests: additionalRequest,
      agreement: consentCheck
    };

    // validation
    const fieldsToValidate = { ...params };
    delete fieldsToValidate.requests;

    for (let key in fieldsToValidate) {
      if (!fieldsToValidate[key]) {
        return toast.error(t('toast.fillAllTheFields'));
      }
    }

    //phone number validation
    if (!validator.isMobilePhone(phone)) {
      return toast.error(t('toast.enterValidPhoneNumber'));
    }

    if (!validator.isEmail(email)) {
      return toast.error(t('toast.enterValidEmail'));
    }

    if (!consentCheck) {
      return toast.error(t('toast.acceptPrivacyPolicy'));
    }

    const response = await apiFunc({
      data: params,
      token: !!accessToken
    });
    if (response?.data) {
      navigate('/');

      toast.success(t('toast.requestSubmitted'));
    }
  };

  const heroData = {
    photo: pageData?.data?.photo,
    title: pageData?.data?.title,
    subTitle: pageData?.data?.description1,
    subTitle2: pageData?.data?.description2
  };

  return (
    <>
      <Header containerClass={''} />
      <div className={classes.main}>
        <HeroSection
          minHeight="490px"
          className={classes.heroSec}
          heroData={heroData}
          bgImage={imageUrl(pageData?.data?.bg)}>
   
        </HeroSection>
        <section className={classes.formSection}>
          <Container className={[classes.container].join(' ')}>
            <div className={classes.mainHeading}>
              <h1>
            
                {pageData?.data?.mainTitle}
              </h1>
              <p>{pageData?.data?.subTitle}</p>
            </div>
            <div className={classes.stepsWrap}>
              {pageData?.data?.arr?.length > 0 &&
                pageData?.data?.arr?.map((e, i) => (
                  <>
                    <div className={classes.step} key={`${e?._id}-${i}`}>
                      <img alt={e?.image} draggable={false} src={imageUrl(e?.image)} className={classes.stepIcon} />
                      <h6>{e?.title}</h6>
                      <p>{e?.description}</p>
                    </div>
                    {i !== pageData?.data?.arr?.length - 1 && <div className={classes.divider} />}
                  </>
                ))}
            </div>
            <div className={classes.formWrap}>
              <Row className={classes.row}>
                <Col md={12}>
                  <h5 className={classes.subheading}>{t('contactDetails')}</h5>
                </Col>
                <Col md={6}>
                  <Input
                    label={t('fullName')}
                    placeholder={t('fullNamePlaceholder')}
                    value={name}
                    setValue={setName}
                  />
                </Col>
                <Col md={6}>
                  <Input
                    label={t('email')}
                    placeholder={t('emailPlaceholder')}
                    value={email}
                    setValue={setEmail}
                  />
                </Col>
                <Col md={6}>
                  <CustomPhoneInput
                    inputClass={classes.phoneInput}
                    label={t('phoneNumber')}
                    placeholder={t('phoneNumberPlaceholder')}
                    value={phone}
                    setter={setPhone}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('preferredMethodOfContact')}
                    placeholder={t('preferredMethodOfContactPlaceholder')}
                    value={contactMethod}
                    setValue={setContactMethod}
                    options={preferredContactMethodOptions}
                  />
                </Col>
                <Col md={12}>
                  <h5 className={classes.subheading}>{t('propertyRequirement')}</h5>
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('enquiryType')}
                    placeholder={t('enquiryTypePlaceholder')}
                    value={enquiryType}
                    setValue={setEnquiryType}
                    options={enquiryTypeOptions}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('propertyType')}
                    placeholder={t('propertyTypePlaceholder')}
                    value={propertyType}
                    setValue={setPropertyType}
                    options={propertyTypesOptions}
                    optionValue={'_id'}
                    getOptionLabel={(e) => {
                      return e?.title[selectedLanguage];
                    }}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('city')}
                    placeholder={t('cityPlaceholder')}
                    value={city}
                    setValue={setCity}
                    options={getCities}
                    optionLabel={'name'}
                    optionValue={'name'}
                  />
                </Col>
                <Col md={6}>
                  <Input
                    label={t('area_street')}
                    placeholder={t('area_streetPlaceholder')}
                    value={street}
                    setValue={setStreet}
                  />
                </Col>
                <Col md={6}>
                  <Input
                    type={'number'}
                    label={t('budget')}
                    placeholder={t('budgetPlaceholder')}
                    value={budget}
                    setValue={setBudget}
                    min={0}
                  />
                </Col>
                <Col md={6}>
                  <Input
                    label={t('area')}
                    placeholder={t('areaPlaceholder')}
                    type={'number'}
                    value={area}
                    setValue={setArea}
                    min={0}
                  />
                </Col>
                <Col md={6}>
                  <Input
                    label={t('rooms')}
                    placeholder={t('roomsPlaceholder')}
                    type={'number'}
                    value={rooms}
                    setValue={setRooms}
                    min={0}
                  />
                </Col>
                <Col md={6}>
                  <Input
                    label={t('bathrooms')}
                    placeholder={t('bathroomsPlaceholder')}
                    type={'number'}
                    value={bathrooms}
                    setValue={setBathrooms}
                    min={0}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('furnishing')}
                    placeholder={t('furnishingPlaceholder')}
                    value={furnishing}
                    setValue={setFurnishing}
                    options={furnishingOptions}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('floorLevel')}
                    placeholder={t('floorLevelPlaceholder')}
                    value={floorLevel}
                    setValue={setFloorLevel}
                    options={floorLevelOptions}
                    optionLabel={[selectedLanguage]}
                    optionValue={[selectedLanguage]}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('propertyStatus')}
                    placeholder={t('propertyStatusPlaceholder')}
                    value={propertyStatus}
                    setValue={setPropertyStatus}
                    options={propertyStatusOptions}
                    optionLabel={[selectedLanguage]}
                    optionValue={[selectedLanguage]}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('parkingSpace')}
                    placeholder={t('parkingSpacePlaceholder')}
                    value={parkingSpace}
                    setValue={setParkingSpace}
                    options={parkingSpaceOptions}
                    optionLabel={[selectedLanguage]}
                    optionValue={[selectedLanguage]}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('viewAndOrientation')}
                    placeholder={t('viewAndOrientationPlaceholder')}
                    value={view}
                    setValue={setView}
                    options={propertyOrientationOptions}
                    optionLabel={[selectedLanguage]}
                    optionValue={[selectedLanguage]}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    label={t('interiorAmenities')}
                    placeholder={t('interiorAmenitiesPlaceholder')}
                    isMulti={true}
                    value={inAmenities}
                    setValue={setInAmenities}
                    options={interiorAmenitiesOptions}
                    optionValue={'_id'}
                    getOptionLabel={(e) => e?.title?.[selectedLanguage]}
                    // getOptionLabel={(e) => e?.title['en']}
                  />
                </Col>
                <Col md={6}>
                  <DropDown
                    isMulti={true}
                    label={t('exteriorAmenities')}
                    placeholder={t('exteriorAmenitiesPlaceholder')}
                    value={exAmenities}
                    setValue={setExAmenities}
                    options={exteriorAmenitiesOptions}
                    optionValue={'_id'}
                    getOptionLabel={(e) => e?.title?.[selectedLanguage]}
                    // getOptionLabel={(e) => e?.title['en']}
                  />
                </Col>
                <Col md={12}>
                  <h5 className={classes.subheading}>{t('additionalRequests')}</h5>
                </Col>
                <Col md={12}>
                  <TextArea
                    value={additionalRequest}
                    setValue={setAdditionalRequest}
                    placeholder={t('additionalRequestsPlaceholder')}
                  />
                </Col>
                <Col md={12} className={classes.btn}>
                  <div className={classes.consent}>
                    {/* <Checkbox value={consentCheck} setValue={setConsentCheck} /> */}
                    <input
                      type="checkbox"
                      id="consentCheck"
                      checked={consentCheck}
                      onChange={(e) => setConsentCheck(e.target.checked)}
                      className={classes.checkboxInput}
                    />
                    {/* <label htmlFor="consentCheck" className={classes.checkboxLabel}> */}
                    <p className={classes.privacyText}>
                      {t('submittingRequest')}{' '}
                      <button
                        className='btnWrapper'
                        onClick={() => navigate('/privacy-policy')}
                        type="button">
                        <span className="c-p">
                          {t('privacyPolicy')}
                        </span>
                      </button>
                   
                    </p>
                  </div>
                  <Button
                    disabled={loading}
                    variant="secondary"
                    label={loading ? t('submitLoading') : t('submit')}
                    onClick={handleSubmit}
                    borderRadius="10px"
                  />
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        <Footer showDownload={false} />
      </div>
    </>
  );
};

export default PropertyRequest;
